module.exports = __webpack_public_path__ + "img/cn.10e54051.svg";